import { render, staticRenderFns } from "./TableBlogs.vue?vue&type=template&id=a36f5a04&scoped=true"
import script from "./TableBlogs.vue?vue&type=script&lang=js"
export * from "./TableBlogs.vue?vue&type=script&lang=js"
import style0 from "./TableBlogs.vue?vue&type=style&index=0&id=a36f5a04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36f5a04",
  null
  
)

export default component.exports